import i18next from 'i18next';
import { pages } from '@dvag/dfs-constant-config';
import { navigate } from '@dvag/dfs-orchestrator-client/messengers';

import { AnalyseBasicSectionListData } from 'type/sectionList';
import { IconName } from '@dvag/design-system-icons/dist/types/types/icon-types';

export interface LeftCardSectionData extends Omit<AnalyseBasicSectionListData, 'path' | 'params'> {
  navigate: (householdId: string) => void;
  isGrouped?: boolean;
  subSections?: LeftCardSectionData[];
  contentIcon?: IconName;
}

const LeftCardEnums = {
  HOUSEHOLD_BUDGET: 'haushaltsbudget-ausgaben',
  CONTRACT_CHECK: 'haushaltsbudget-vertragsuebersicht',
  PENSION: 'basisdaten-staatliche-rente',
  LIVING_SITUATION: 'basisdaten-wohnsituation',
  BALANCE_SHEET: 'vermoegensbilanz',
};

export const { HOUSEHOLD_BUDGET, CONTRACT_CHECK, PENSION, LIVING_SITUATION, BALANCE_SHEET } =
  LeftCardEnums;

export const leftCardSections: LeftCardSectionData[] = [
  {
    id: HOUSEHOLD_BUDGET,
    title: i18next.t('dashboardCards.financialContent.householdBudget'),
    icon: 'immobilienfinanzierung',
    navigate: (householdId: string) => {
      navigate(pages.FFG_HOUSEHOLD_BUDGET.getUrl(householdId, true));
    },
  },
  {
    id: CONTRACT_CHECK,
    title: i18next.t('dashboardCards.financialContent.contractReview'),
    icon: 'klemmbrett',
    navigate: (householdId: string) => {
      navigate(pages.FFG_CONTRACT_OVERVIEW.getUrl(householdId, true));
    },
  },
  {
    id: PENSION,
    title: i18next.t('dashboardCards.financialContent.pensionInformation'),
    icon: 'sessel',
    navigate: (householdId: string) => {
      navigate(
        pages.PENSION.getUrl(householdId, true),
        pages.LIVING_SITUATION.getUrl(householdId, true),
      );
    },
  },
  {
    id: LIVING_SITUATION,
    title: i18next.t('dashboardCards.financialContent.livingSituation'),
    icon: 'haus',
    navigate: (householdId: string) => {
      navigate(
        pages.LIVING_SITUATION.getUrl(householdId, true),
        `/berater${window.location.pathname}`,
      );
    },
  },
  {
    id: BALANCE_SHEET,
    title: i18next.t('dashboardCards.financialContent.balanceSheet'),
    icon: 'rechtsschutz-02',
    navigate: (householdId: string) => {
      navigate(pages.FINANCIAL_BALANCE_SHEET.getUrl(householdId, true), undefined, true);
    },
  },
];
